import * as React from "react";
import Form, {
  AjvError,
  FormProps,
  ObjectFieldTemplateProps,
} from "react-jsonschema-form";
import DefaultRenderer from "./schemaform/default-renderer";
import LayoutRenderer from "./schemaform/layout-renderer";
import DateWidget from "./schemaform/date-widget";
import DateTimeWidget from "./schemaform/date-time-widget";

/**
 * Este es un wrapper sobre el schema form de mozilla.
 *
 * Agrega algunos estilos y deja presentable el formulario.
 *
 * Para una mejor version probar usar:
 * https://github.com/networknt/react-schema-form
 */

interface EnhancedSchemaFormProps<T> extends FormProps<T> {}

const DescriptionField = (props: any) => {
  const { id, description } = props;
  if (!description) {
    // See #312: Ensure compatibility with old versions of React.
    return <div />;
  }
  if (typeof description === "string") {
    return (
      <p id={id} className="field-description">
        {description}
      </p>
    );
  } else {
    return (
      <div id={id} className="field-description">
        {description}
      </div>
    );
  }
};

const TitleField = (props: {
  id?: string;
  title?: string;
  required?: boolean;
  formContext?: any;
}) => {
  const { id, title, required } = props;
  const legend = required ? title + " *" : title;
  return <legend id={id}>{legend}</legend>;
};

const renderGrid = (props: ObjectFieldTemplateProps) => {
  if (props.uiSchema["ui:layout"]) {
    return LayoutRenderer(props);
  }
  return DefaultRenderer(props);
};

const ObjectRenderer = (props: ObjectFieldTemplateProps) => {
  return (
    <fieldset>
      {(props.uiSchema["ui:title"] || props.title) && (
        <TitleField
          id={`${props.idSchema.$id}__title`}
          title={props.title || props.uiSchema["ui:title"]}
          required={props.required}
          formContext={props.formContext}
        />
      )}
      {props.description && (
        <DescriptionField
          id={`${props.idSchema.$id}__description`}
          description={props.description}
          formContext={props.formContext}
        />
      )}
      {renderGrid(props)}
    </fieldset>
  );
};

const widgets = {
  DateWidget: DateWidget,
  DateTimeWidget: DateTimeWidget,
};

class SchemaForm extends React.Component<EnhancedSchemaFormProps<any>> {
  static transformErrors(errors: AjvError[]) {
    return errors.map((error) => {
      if (error.name === "required") {
        error.message = "Campo requerido";
      }
      if (error.name === "existName") {
        error.message = "El nombre ya existe, intente con otros datos";
      }
      if (error.name === "existEmail") {
        error.message = "El correo ya existe, intente con otros datos";
      }
      if (
        error.name === "format" &&
        error.params &&
        error.params.format === "email"
      ) {
        error.message = "Debe ser un correo bien formateado";
      }
      if (error.name === "minLength") {
        error.message = `Debe ser mas al menos de ${error.params.limit} caracteres`;
      }
      return error;
    });
  }

  constructor(props: EnhancedSchemaFormProps<any>) {
    super(props);
    console.log("A ver aca porque no mapea:", props);
  }

  render() {
    return (
      <Form
        liveValidate={false}
        noHtml5Validate={true}
        transformErrors={SchemaForm.transformErrors}
        showErrorList={false}
        ObjectFieldTemplate={ObjectRenderer}
        widgets={widgets}
        {...this.props}
      >
        {this.props.children && this.props.children}
      </Form>
    );
  }
}

export default SchemaForm;



// WEBPACK FOOTER //
// ./src/components/schemaForm.tsx